import { createFileRoute } from "@tanstack/react-router";
import { GeneralSettingsEditor } from "@/features/admin-general/GeneralSettingsEditor";
function Page() { const { session } = Route.useRouteContext(); return <GeneralSettingsEditor key={session.user.id} actorId={session.user.id} />; }
export const Route = createFileRoute("/_authenticated/_protected/_admin/admin/general")({ component: Page });
